export const ES = {
  banner: {
    error: "Las cotizaciones no están actualizadas, por favor espera",
    copicate: "Pruebe el nuevo modo de cartera!",
    antimonitor:
      "El mejor sito para comprar y operar con criptodivisas ¡Haz clic aquí!",
  },
  footer: {
    donating:
      "Si te gusta CoinTrackr, por favor, no dudes en hacer una donación.",
    right_reserve:
      "© Copyright " +
      new Date().getFullYear() +
      " por CoinTrackr.com. Algunos derechos reservados.",
    version: "Versión",
    changelog: "Registro de cambios",
    powered_by: "Desarrollado por",
  },
  top: {
    about: {
      info: "Información",
      FAQ: "Preguntas frecuentes",
      contact: "Contacto",
      partners: "Socios",
      terms: "Términos",
      privacy: "Privacidad",
    },
  },
  content: {
    valuation: {
      current_valuation: "Valoración actual",
      approx: "Aproximadamente",
    },
    profit_losses: "Beneficios y pérdidas",

    updating_assets: "Actualización de activos",
    updated_now: "Recién actualizado",
    last_update: `Última actualización hace {time} segundos`,
    last_update_minutes: `Última actualización hace {minutes} min. y {seconds} seg.`,
  },
  assets: {
    your_assets: "Activos",
    add_asset: "Añadir activo",
    sort: "Ordenar por",
    sort_name: {
      name: "Nombre",
      exchId: "Intercambio",
      price: "Precio",
      value: "Valoración",
      holdings: "Participaciones",
      percChangeHour: "Hora",
      percChangeDay: "Día",
      percChangeWeek: "Semana",
    },
  },
  charts: {
    color_help: "Haz clic en un círculo para cambiar un color",
  },
  contact_page: {
    contact: "Contacto",
    help_feedback: "Ayuda y Comentarios",
    telegram: "Telegram",
    twitter: "Twitter",
    medium: "Medium",
    busines: "Consultas empresariales",
    email: "Correo electrónico",
  },
  partner_page: {
    partners: "Nuestros socios",
    bitsify:
      "Bitsify ofrece informes completos y detallados sobre las próximas ICO y Crowdsale",
    bitcoin:
      "Bitcoin for Beginners es una comunidad apta para principiantes para aprender a operar con criptodivisas.",
    interest: "¿Estás interesado en asociarte?",
    contact_us: "¡Contáctanos!",
  },
  user_menu: {
    not_logged: "No has iniciado sesión ",
    icognito: "Incógnito",
    settings: "Configuración",
    sign_in: "Iniciar sesión",
    sign_out: "Cerrar sesión",
    valuation: "Mostrar valoración en la ficha",
    incognito: "Modo incógnito",
    night_mode: "Modo nocturno",
    share_link: "Crear enlace compartible",
  },
  FAQ: {
    expand: "Ampliar todo",
    collapse: "Reducir todo",
    0: {
      title: "¿Qué es CoinTrackr?",
      text:
        "CoinTrackr es un servicio gratuito, sencillo y cómodo diseñado para ayudar a seguir inversiones en criptodivisas.",
    },
    1: {
      title: "¿Cómo puedo crear mi propia cartera en CoinTrackr?",
      text:
        "Es muy sencillo. Sólo tienes que eliminar los activos de la cartera de ejemplo y sustituirlos por los tuyos propios. Puedes eliminar o editar un activo haciendo clic en él.",
    },
    2: {
      title:
        "¿De dónde obtiene CoinTrackr los precios de las criptomonedas y son exactos?",
      text:
        'Todos los datos de precios provienen de <a href="https://coinmarketcap.com">coinmarketcap.com</a>, y representan el precio medio entre los intercambios que son compatibles con CoinMarketCap. Dado que CoinTrackr utiliza precios medios, éstos pueden diferir ligeramente del precio exacto de los intercambios que estás siguiendo.',
    },
    3: {
      title: "¿Cómo puedo añadir mi clave API y Trading desde Cointrackr?",
      text:
        'Solo tienes que seguir las instrucciones de nuestra página dedicada <a href="/exchange/how-it-works">aquí</a>.',
    },
    4: {
      title: "¿Planeas añadir más Intercambios?",
      text:
        "Sí, tenemos previsto añadir el mayor número posible de Intercambios que ofrezcan la posibilidad de generar una Clave API para sus clientes.",
    },
    5: {
      title: "¿Cuál es la valoración y cómo se determina el importe?",
      text:
        "La valoración es el valor total de todos tus activos añadidos a CoinTrackr; el valor total de tu cartera de criptomonedas actual.",
    },
    6: {
      title: "¿Por qué no puedo encontrar algunas criptomonedas?",
      text:
        "Si has escrito bien el nombre de la criptomoneda y no se puede encontrar, parece que CoinMarketCap no es compatible con esa criptomoneda aún. Estamos trabajando para añadir múltiples fuentes de datos de precios, así que es muy probable que tu criptomoneda sea compatible en el futuro.",
    },
    7: {
      title: "¿Cómo guardáis mi cartera y mis datos de acceso?",
      text:
        "Si no estás conectado, todos los datos se guardan en la memoria caché de tu navegador. Puedes cerrar la ventana y volver más tarde, sin necesidad de volver a añadir tus activos.." +
        "\n" +
        "Si te has registrado en CoinTrackr ( inicio de sesión social/correo electrónico y contraseña), tus datos se almacenan en nuestra base de datos. Esto lo hacemos para que sea posible la sincronización en tiempo real entre tus diferentes dispositivos (por ejemplo, escritorio y móvil) y para que los datos se almacenen incluso si borras la memoria caché del navegador.",
    },
    8: {
      title: "¿Es seguro crear una cuenta CoinTrackr?",
      text:
        'Sí. Sólo utilizamos tus datos para hacer posible el funcionamiento clave de CoinTrackr. En ningún caso cedemos tus datos a terceros. Por favor, consulta nuestra <a href="/privacy">Política de privacidad</a> para obtener una información más detallada.',
    },
    9: {
      title:
        "¿Estaría CoinTrackr interesado en cooperar con mi servicio/comunidad relacionada con las criptomonedas?",
      text:
        'Posiblemente. ¡Por favor, <a href="/contact">contacta<a/> con nosotros para debatir las posibilidades!',
    },
  },
  add_page: {
    search: "Buscar por nombre o por símbolo",
    add_asset: "Añadir activo",
    any_asset: {
      1: "Cualquier activo (moneda o token) que cotice en",
      2: "es compatible",
    },
    next: "Siguiente",
    no_result: "No se han encontrado resultados para",
  },
  register_page: {
    register: "Inscripción",
    agree: "Al inscribirte, aceptas nuestros",
    terms: "Términos y condiciones",
    and: "y",
    privacy: "Política de privacidad",
    p_reg:
      "Es necesario registrarte si quieres <b>guardar tu cartera</b> para usarla en <b>otros dispositivos</b>, o protegerte de perderla <b>en caso de que borres la memoria caché de tu navegador.</b>",
    errors: {
      email_required: "Se requiere una dirección correo electrónico.",
      email_valid: "La dirección de correo electrónico debe ser válida",
      password_required: "Se requiere contraseña.",
      password_length: "La contraseña debe tener al menos {length} caracteres.",
      password_match: "Las contraseñas deben coincidir.",
    },
    placeholder: {
      email: "Introduce tu correo electrónico",
      password: "Introduce tu contraseña",
      password_repeat: "Repite tu contraseña",
    },
    create_account: "Crear cuenta",
  },
  login_page: {
    placeholder: {
      email: "Introduce tu correo electrónico",
      password: "Introduce tu contraseña",
    },
    errors: {
      email_not_found:
        "No hay ningún registro de usuario correspondiente a este identificador. Puede que el usuario haya sido eliminado.",
      not_email: "La dirección de correo electrónico está mal formateada.",
    },
    forget_password_text:
      "Si olvida su contraseña, haga clic aquí para restablecerla",
    forget_password_text_back: "volver a Iniciar sesión",
    reset_password: "Restablecer la contraseña",
    reset_password_p:
      "Ingrese su dirección de correo electrónico a continuación y le enviaremos un correo electrónico para restablecer su contraseña.",
    reset_password_success:
      "Se ha enviado un mensaje de restablecimiento de contraseña para CoinTrackr. Revisa tu bandeja de entrada y vuelve.",
    // forget_password_text: 'Si olvidaste tu contraseña, envíanos un correo electrónico a : <a href="mailto:info@cointrackr.com">info@cointrackr.com</a> para restablecerla',
  },
  share_page: {
    heading: "Crear enlace compartible",
    just_second: "Un momento...",
    porfolio_not_found: "Cartera no encontrada",

    p_1:
      "<strong>CoinTrackr</strong> es un <strong>gestor de carteras de criptodivisas</strong> gratuito que te permite seguir tus beneficios y tus pérdidas y <strong>compartir tu cartera con otras personas</strong>.",
    create_own: "Crea el tuyo de manera gratuita",

    p_2:
      "<strong>Alguien compartió su cartera contigo!</strong> <br> CoinTrackr es un servicio gratuito de cartera de criptodivisas compatible con más de 4.000 monedas y tokens.",
    porfolio: "Cartera",
    profit_losed: "Beneficios y pérdidas",

    created: "Creado",
    dialog: {
      p_1:
        "Al compartir tu cartera se crea un <strong>enlace público</strong> que muestra tu <strong>cartera anónima.</strong> Sólo contiene <strong>porcentajes</strong> y ninguna valoración ni precio. No se puede vincular contigo y se puede compartir de forma segura con cualquier persona.",
      add_message: "<strong>Añadir mensaje</strong> <em>(opcional)</em>",
    },
    create_shareble: "Crear enlace compartible",
    create_own_free: "Crea tu propia cartera",
    messages: {
      already: "¡El enlace de tu cartera está listo para ser compartido! 🙌",
      copied: "¡Tu enlace fue copiado! 🎉",
      not_copied:
        "Tu enlace no ha podido ser copiado. Por favor, cópialo manualmente. 😢",
      failed:
        "La creación del enlace ha fallado, por favor, inténtalo de nuevo. 😢",
    },
  },
  global: {
    add_first: "Añade tu primer activo",

    not_now: "Ahora no",
    not_right_now: "Ahora mismo no",
    close: "Cerrar",
    go_back: "Volver a la página anterior",
    share: "Compartir%",

    price: "Precio",

    day: "Día",
    hour: "Hora",
    week: "Semana",
    valuation: "Valoración",
    holdings: "Participaciones",
    name: "Nombre",
    actions: "Acciones",
    edit: "Editar",
    notes: "Notes",

    last_7_days: "Últimos 7 días",
    last_24_hour: "Últimas 24 horas",
    last_hour: "Última hora",

    login: "Acceso ",
  },
  sign_in_dialog: {
    button: {
      email: "Iniciar sesión con correo electrónico",
      facebook: "Iniciar sesión con Facebook",
      google: "Iniciar sesión con Google",
      twitter: "Iniciar sesión con Twitter",
    },
    p:
      "Es necesario iniciar sesión si quieres <b>guardar tu cartera</b> para usarla en <b>otros dispositivos</b>, o protegerte de perderla <b>en caso de que borres la memoria caché de tu navegador</b>.",
  },
  notifications: {
    sign_in: "Has iniciado sesión.",
    sign_out: "Has cerrado sesión.",
    HODL: "¿No te quedas 😭?",
    dont_worry: "¡No te preocupes, sé feliz .... y guarda! 🎶 🚀",
  },
  edit_asset_page: {
    add: "Añadir o editar",
    how_much: "¿Qué cantidad de {assetName} {assetSymbol} tienes?",
    save: "Guardar",
    delete: "Borrar",
    notes_label: "Notas para {assetName} {assetSymbol}",
    notes_placeholder:
      "Añade aquí tus notas como el precio de compra, el intercambio, la dirección de la cartera o cualquier otro comentario relacionado con el activo",
  },
  exchange: {
    exchange: "Intercambio",
    trade: "Trading",

    your_api_keys: "Tus claves API",
    how_it_works: "¿Cómo funciona?",

    home_valuation_per_exchange: "Valoración por Intercambio",
    home_show_valuation_per_exchange: "Mostrar Valoración por Intercambio",
    home_tooltip_info:
      "Ver la información acerca de las Claves API de Intercambio",

    api_key: "Clave API",
    secret: "Secreto",
    add: "Añadir",
    update: "Actualizar",
    cancel: "Cancelar",
    add_your_exchange_api_key: "Añade tu Clave API de {exchange}",
    add_exchange_api_key: "Añadir Clave API de {exchange} ",
    update_exchange_api_key: "Actualizar Clave API de {exchange} ",
    api_keys_page_note:
      "Importante: Hay un retraso de 15 min. de actualización de Binance después de un depósito/retirada y cualquier orden completada.<br /> Las cotizaciones son en directo",

    pick_a_ticker_to_trade: "Escoge un Ticker para operar:",
    select_ticker: "Seleccionar ticker",

    loading: "Cargando..",
    Buy: "Comprar",
    Sell: "Vender",
    LIMIT: "LIMITE",
    MARKET: "MERCADO",

    amount: "Cantidad",
    you_have: "Tienes",
    total: "Total",

    place_buy_order: "Hacer un pedido de COMPRA",
    place_sell_order: "Hacer un pedido de VENTA",

    order_placed: "¡Pedido realizado!",

    you_dont_have_assets: "No tienes activos con los que comerciar",

    orders_history: "Historial de Órdenes",
    orders_open: "Órdenes Abiertas",
    orders_history_empty: "El Historial de Ordenes de {ticker} está Vacío",
    orders_open_empty: "No hay Órdenes Abiertas de {ticker} en este momento",
    symbol: "Símbolo",
    side: "Lado",
    type: "Tipo",
    price: "Precio",
    status: "Estado",
    stopPrice: "Precio de Cierre",
    executedQty: "ExecQty",
    time: "Fecha",
    action: "Acción",
  },
  exchange_info_page: {
    blocks: [
      {
        heading: "Actualización Importante de CoinTrackr",
        p: [
          "Después de años de servir docenas y miles de millones de cotizaciones de forma gratuita para todos nuestros valiosos usuarios, CoinTrackr se enorgullece de anunciar un gran Avance, ¡a partir de hoy puedes seguir tus Criptoactivos reales que tienes en varios Intercambios directamente en Cointrackr!",
          "Una cosa más.... ¡No solo seguimiento! Cointrackr también se complace en anunciar una función de trading para estos activos, lo que significa que podrás seguirlos y comerciar con ellos dentro de Cointrackr.",
        ],
      },
      {
        heading: "¿Cómo funciona?",
        p: [
          "Todos los grandes intercambios permiten a los usuarios utilizar una API para conectarse a otra plataforma. Por ejemplo, como puedes ver a continuación, Binance ofrece esta opción en este espacio:",
          '1) Inscríbete en CoinTrackr, luego ve al menú "Tu clave API"',
          "2) Copia y pega desde tu cuenta de Binance tu clave API y tu clave secreta.<br /> Aquí una imagen rápida que describe los pasos:",
          "<em>IMPORTANTE</em>: Activar SOLO “<strong>Activar lectura</strong>” y “<strong>Activar trading al Contado y con Margen</strong>” ; Y en Restricción de IP establece la dirección IP de CoinTrackr <strong>{exchangeApiIP}</strong>",
          "Una vez hecho esto, por favor espera 15 minutos para la sincronización, vete a la página de inicio y verás tu activo de Binance representado por el logo de Binance.",
          'También hay una diferencia importante, antes en los activos clásicos de CoinTrackr tenías el botón Editar, obviamente este botón se convirtió en "Operar", porque a partir de hoy puedes gestionar y negociar tu cartera de Intercambio directamente en CoinTrackr.',
          "Veamos cómo es ahora tu panel de control de CoinTrack:",
          "También ahora, en la primera página, tendrás la diferenciación con tu activo mantenido en Binance y Classic CoinTrackr.",
          "Como puedes ver tienes una nueva columna, diferenciando tu activo por intercambio.<br /> > El logo de Cointrackr se establece para tu activo real clásico que siempre has rastreado.<br /> > Binance aquí, se rastrea tu activo real en tu cuenta en directo de Binance.",
        ],
      },
      {
        heading: "Plataforma de Trading",
        p: [
          "(Tras aceptar nuestros Términos y Condiciones)",
          'Ahora veamos la plataforma de trading CoinTrackr, a la que puedes acceder en cualquier momento haciendo clic en "Operar" en cada uno de tus activos de intercambio:',
          'Como puedes ver aquí, después de hacer clic en "Operar" tienes opciones de: <br /> "Comprar / Vender", con dos opciones "Orden limitada" y "Mercado" tu activo subyacente',
          'Nota: para habilitar esta opción, debes elegir autorizar el trading cuando crees una API de Binance con la opción "Habilitar trading al contado y con margen", por favor haz <a href="#step-2-binance-setup">clic aquí para ver la configuración de Binance nuevamente</a>.',
          "Si no quieres utilizar esta función, podrás seguir rastreando tu activo como lo hacías antes.",
          "Hoy el primer Intercambio que ofrecemos a seguir es Binance, próximamente más :)",
          '<a href="mailto:info@cointrackr.com">info@cointrackr.com</a>  si tienes alguna pregunta o si encuentras algún error. ¡Gracias!',
        ],
      },
    ],
  },
  profitloss: {
    pl: "B/P",
    profitloss: "Beneficios/Pérdidas",
    realized_profitloss: "Ganancias/pérdidas obtenidas",
    total_balance: "Balance total",
    mode: "modo",
    portfolio: "Cartera",
    current: "Actual",
    history: "Historial",
    investment: "Inversión",
    average: "Media",
    transaction: "Transacción",
    transactions: "Transacciones",
    hide: "Ocultar",
    show: "Mostrar",
    asset_notes_label: "Notas para este activo",
    asset_notes_placeholder: "Añade aquí cualquier nota relacionada con este grupo de Transacciones de Activos",
    reset_portfolio: "Restablecer cartera",
    reset_portfolio_text: "¿Quieres borrar todas las transacciones?",
    list_empty: "La lista está vacía.",

    quantity: "Cantidad",
    value: "Valor",
    date: "Fecha",
    buy_price: "Precio de compra",
    buy_value: "Valor de compra",
    buy_date: "Fecha de compra",
    showInValuation_help: "Incluir la B/P en la valoración actual",
    transaction_notes_placeholder: "Añade aquí cualquier nota relacionada con esta transacción",
    sell_close: "Vender / Cerrar",
    total_valuation: "Valoración total",
    delete_transaction_text: "¿Borrar esta transacción?",

    sell_price: "Precio de venta",
    sell_value: "Valor de venta",
    sell_date: "Fecha de venta",
    history_transaction_hint: "Esta es una transacción cerrada",

    original_buy_transaction: "Transacción de compra original del {date}",
    left_unsold: "no se vendió",
    originally: "originalmente",
    dependent_transactions: "Tienes {count} transacciones cerradas dependientes de ésta por un total de {amount}",
  },
};
